import i18n from 'i18next';

const getOptionAttributes = (options = [], type = 'String') => {
  let parseOptions = ({ value, text }, index) => ({
    label: text,
    value: index,
    realValue: value,
  });
  switch (type) {
    case 'Array[Integer]':
      parseOptions = ({ value, text }, index) => ({
        label: text,
        value: index,
        realValue: [parseInt(value || '-1', 10)],
      });
      break;
    default:
      // Already set
      break;
  }

  return { options: options.map(parseOptions).filter(Boolean) };
};

const getFilterAttributes = (filter = {}) => {
  if (!filter.enabled) { return false; }
  const defaultValue = filter.options.findIndex(({ value }) => (value === filter.default_value));
  return {
    ...filter,
    defaultValue: defaultValue || 0,
    key: filter.field || filter.key,
    label: filter.label || i18n.t(`filter_${filter.key}_label`),
    ...getOptionAttributes(filter.options, filter.field_type),
  };
};

export default (filters = []) => filters.map(getFilterAttributes).filter(Boolean);
